import { render } from "./FlowDocumentRequest.vue?vue&type=template&id=55ca00fc&bindings={\"current\":\"props\",\"items\":\"setup\"}"
import script from "./FlowDocumentRequest.vue?vue&type=script&lang=ts"
export * from "./FlowDocumentRequest.vue?vue&type=script&lang=ts"
script.render = render

export default script